import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

const persistConfig = {
  key: "root",
  storage,
  blacklist: [
    "toast",
    "coinSelect",
    "coinFromValue",
    "coinSelect",
    "walletAddress",
    "extraId",
    "exchangeRes",
    "selectedExchange",
    "netExtra",
  ],
  whitelist: ["netIcone", "history"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
